<template>
  <div class="mpContext" v-html="context"></div>
</template>
<script>
export default {
  props: {
    context: {
      type: String,
      default: ""
    }
  }
};
</script>
<style scoped>
.mpContext {
  padding: 8px 5px;
}
</style>
